import * as React  from "react"
import Directory from "../components/Directory"

const IndexPage = () =>
{

return(

  <Directory />

)
}

export default IndexPage

